/* MYPARF — sticky mobile buy bar.
   Shows the bar when the main buy buttons leave the viewport (IntersectionObserver).
   Third pass: the bar proxies the COD Quick Order button when present — the
   PRIMARY buying path on this store — and falls back to the add-to-cart submit
   otherwise. The click is forwarded to the real in-form button, so the Quick
   Order delegation reads variant/price live and stays authoritative. */
(function () {
  var bar = document.querySelector('.myparf-sticky-atc');
  if (!bar) return;
  var mainSubmit = document.querySelector('product-form .product-form__submit, form[data-type="add-to-cart-form"] [type="submit"]');
  var qoButton = document.querySelector('product-form [data-qo-buy-now], .product-form__buttons [data-qo-buy-now]');
  var target = qoButton || mainSubmit;
  var buyArea = document.querySelector('.product-form__buttons') || target;
  if (!target || !buyArea) return;

  var proxy = bar.querySelector('[data-sticky-add]');
  if (!qoButton && mainSubmit) {
    // no Quick Order rendered (COD off or variant unavailable): label follows the ATC
    proxy.textContent = mainSubmit.textContent.trim() || proxy.textContent;
  }
  proxy.addEventListener('click', function () {
    if (target.disabled) return;
    target.click();
  });

  // sync only the disabled state (sold-out variants); never copy the ATC label
  // over the Quick Order one.
  if (mainSubmit) {
    var sync = function () {
      proxy.disabled = mainSubmit.disabled;
      if (!qoButton) proxy.textContent = mainSubmit.textContent.trim() || proxy.textContent;
    };
    new MutationObserver(sync).observe(mainSubmit, { attributes: true, childList: true, subtree: true });
  }

  // keep the price in sync when the variant changes (Dawn re-renders the price area)
  var priceEl = bar.querySelector('[data-sticky-price]');
  var mainPrice = document.querySelector('.product__info-container .price__regular, .product__info-container .price');
  if (priceEl && mainPrice) {
    new MutationObserver(function () {
      var current = document.querySelector('.product__info-container .price__sale .price-item--sale, .product__info-container .price__regular .price-item--regular');
      if (current) priceEl.textContent = current.textContent.trim();
    }).observe(mainPrice, { childList: true, subtree: true, characterData: true });
  }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries) {
        var visible = entries[0].isIntersecting;
        bar.classList.toggle('is-visible', !visible);
        bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
      },
      { rootMargin: '-60px 0px 0px 0px' }
    ).observe(buyArea);
  }
})();
